/* global KSU */

YUI.add('social-icons', function (Y) {

"use strict";

/* SocialIcons class constructor */
var SocialIcons = function() {
    //console.log("Creating new SocialIcons");
    SocialIcons.superclass.constructor.apply(this, arguments);
};

/*
 * Required NAME static field, to identify the class and
 * used as an event prefix, to generate class names etc. (set to the
 * class name in camel case).
 */
SocialIcons.NAME = "SocialIcons";

/*
 * Required NS static field, to identify the property on the host which will,
 * be used to refer to the plugin instance ( e.g. host.feature.doSomething() )
 */
SocialIcons.NS = "socialIcons";

/*
 * The attributes for the plugin.
 */
SocialIcons.ATTRS = {
};


 /* SocialIcons extends the base Plugin.Base class */
Y.extend(SocialIcons, Y.Plugin.Base, {

    initializer: function() {

        console.log("Initializer");

        this.render();

    },

    render: function() {

        var HOST = "host", host, html, config,

            // Sites are not in alphabetical order, because this is the order the icons appear.
            sites = [
                {name: "Facebook",    prop: "facebookUrl",    clazz: "ksu-facebook-icon"},
                {name: "Twitter",     prop: "twitterUrl",     clazz: "ksu-twitter-icon"},
                {name: "YouTube",     prop: "youtubeUrl",     clazz: "ksu-youtube-icon"},
                {name: "Flickr",      prop: "flickrUrl",      clazz: "ksu-flickr-icon"},
                {name: "Foursquare",  prop: "foursquareUrl",  clazz: "ksu-foursq-icon"},
                {name: "Google Plus", prop: "googlePlusUrl",  clazz: "ksu-gplus-icon"},
                {name: "Instagram",   prop: "instagramUrl",   clazz: "ksu-instagram-icon"},
                {name: "LinkedIn",    prop: "linkedinUrl",    clazz: "ksu-linkedin-icon"},
                {name: "Picasa",      prop: "picasaUrl",      clazz: "ksu-picasa-icon"},
                {name: "Pinterest",   prop: "pinterestUrl",   clazz: "ksu-pinterest-icon"},
                {name: "Vimeo",       prop: "vimeoUrl",       clazz: "ksu-vimeo-icon"},
                {name: "RSS",         prop: "rssUrl",         clazz: "ksu-rss-icon"},
                {name: "Blog",        prop: "blogUrl",        clazz: "ksu-blog-icon"}
            ];

        host = this.get(HOST);

        if (!host) {
            return;
        }

        if (host.one(".ksu-unit-social")) {
            // There already are icons here -- don't add more.
            return;
        }

        html = "<ul class='ksu-unit-social'>";
        config = KSU.config;

        Y.Array.forEach(sites, function(site) {
            if (config[site.prop]) {
                html += "<li><a class='" + site.clazz + "' href='" + config[site.prop] + "' aria-label='" + site.name + "'></a></li>";
            }
        });

       html += "</ul>\n";

       host.append(html);

    }

 });

 Y.namespace("Plugin").SocialIcons = SocialIcons;


}, '2.0.0', {"requires": ["node", "plugin"]});
